import { sample } from 'effector';
import { delay } from 'patronum';
import { MOUNT_DELAY } from '@consts/delay';
import { fxGetUnreadCount, type Lang } from '../unread-count';
import {
  NewsFeedGate,
  updateUnReadCount,
  $isOpenPopover,
  togglePopover,
  showPreviewNews,
  $previewNews,
  onClickPreview,
} from './news-feed.model';

$isOpenPopover.on(togglePopover, (_, isOpen) => isOpen).reset([onClickPreview]);

$previewNews.on(showPreviewNews, (_, news) => news).reset([onClickPreview]);

sample({
  clock: showPreviewNews,
  fn: () => true,
  target: togglePopover,
});

const delayedOpen = delay({
  source: NewsFeedGate.open,
  timeout: MOUNT_DELAY,
});

sample({
  clock: [delayedOpen, updateUnReadCount, showPreviewNews],
  fn: () => ({
    lang: (localStorage.getItem('lang') as Lang) ?? 'ru',
  }),
  target: fxGetUnreadCount,
});
